import api from "../../../api/api";

/* =========================
   FILTER INTERFACES
========================= */

export interface BulkTransferFilters {
  vertical_id?: number;
  role_id?: number;
  responsible_user_id?: number;
  page?: number;
}


/* =========================
   MASTER APIs
========================= */

/**
 * 🔹 Get Verticals
 * GET /hr/v1/verticals/
 */
export const getVerticals = () => {
  return api.get("/hr/v1/verticals/");
};


/**
 * 🔹 Get Roles (Bulk Transfer Only)
 * GET /hr/v1/roles/?bulk_transfer=true&exclude_hr=
 */
export const getRolesForBulkTransfer = () => {
  return api.get("/hr/v1/roles/", {
    params: {
      bulk_transfer: true,
      exclude_hr: "",
    },
  });
};


/**
 * 🔹 Get Responsible Users
 * (Assumed endpoint — adjust if backend differs)
 * GET /hr/v1/users/?vertical_id=&role_id=
 */
/**
 * 🔹 Get Responsible Users
 * GET /crm/v1/responsible-user/
 */
export const getResponsibleUsers = (params: {
  vertical_id?: number;
  role?: string;
}) => {
  return api.get("/crm/v1/responsible-user/", {
    params: {
      vertical_id: params.vertical_id ?? "",
      stage_id: "",
      exclude_role: "",
      role: params.role ?? "",
      bulk_transfer: true,
    },
  });
};

/* =========================
   LIST INQUIRIES FOR TRANSFER
========================= */

/**
 * 🔹 Get Glazing Enquiries (Bulk Transfer Listing)
 * GET /crm/v1/glazing-enquiry/
 * Only vertical is required
 */
export const getInquiriesForTransfer = (
  page: number,
  verticalId: number,
  assignedTo: string,
  pageSize?: number
) => {
  return api.get("/crm/v1/glazing-enquiry/", {
    params: {
      page,
      page_size: pageSize,
      vertical: verticalId,
      assigned_to: assignedTo,   // 🔥 string now

      architect: "",
      client_name: "",
      contact: "",
      last_activity: "",
      ordering: "",
      probability: "",
      quotation: "",
      rfq: "",
      stage: "",
      status: "",
    },
  });
};

/* =========================
   BULK TRANSFER
========================= */

/**
 * 🔹 Transfer Inquiries
 * POST /crm/enquiry/bulk-transfer/
 */
export const bulkTransferInquiries = (
  payload: {
    enquiry_ids?: number[];
    transfer_to: number;
    reason: string;
    confirm: boolean;
    select_all?: boolean;   // ✅ ADD THIS
  },
  params?: {
    vertical?: number;
    assigned_to?: string;
  }
) => {
  return api.post("/crm/enquiry/bulk-transfer/", payload, {
    params: {
      vertical: params?.vertical,
      assigned_to: params?.assigned_to,
    },
  });
};